import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorMessage from "components/reusable/ErrorMessage";
import Toolbar from "components/Toolbar";
import useToastContext from "hooks/useToastContext";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function ForgotPassword() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const notification = useToastContext();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });
  const onSubmit = async (data) => {
    let res;
    setLoading(true);
    try {
      res = await apiPost(pathObj.forgotPassword, { username: data.username });
      if (res.data.success) {
        notification.success(res.data.message);
        reset();
        navigate("/otp", {
          state: {
            type: "username",
            username: data.username,
          },
        });
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      notification.error(res?.data?.message);
    }
    setLoading(false);
  };

  const preventSpace = (e) => {
    if (e?.which === 32) {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className="flex justify-center grid grid-cols-2 items-center w-full h-screen no-scrollbar">
        <div className="hidden md:flex col-span-1 h-full bg-primary justify-center items-center">
          <div>
            <img className="h-[5rem] cursor-pointer" src="images/whitelogo.svg" alt="LOGO" />
          </div>
        </div>
        <div className="w-full col-span-2 md:col-span-1 h-screen overflow-auto flex flex-col items-center justify-start">
          <Toolbar title={t("FORGOT_PASSWORD")} showBackBtn={true} forceShowBack={true} forceTitleCenter={true} />
          <div className="flex items-center justify-center">
            <form className="max-w-sm w-[90%] md:w-[20rem]" onSubmit={handleSubmit(onSubmit)}>
              <div className="gx-sm-4 gx-2">
                <div className="mb-5">
                  <input
                    type="text"
                    id="username"
                    className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                    placeholder={t("USERNAME")}
                    onKeyDown={(e) => preventSpace(e)}
                    {...register("username", {
                      required: t("REGISTER_USERNAME"),
                    })}
                    required
                  />
                  <ErrorMessage message={errors?.username?.message} />
                </div>
                <div className="w-full mt-5">
                  {loading ? (
                    <div className="btn btn_theme w-full flex items-center justify-center p-3">
                      <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                    </div>
                  ) : (
                    <button className="btn btn_theme w-full text-white" type="submit">
                      {t("CONTINUE")}
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
